export default "__VITE_ASSET__jX6IawXk__"